import React from "react";
import { useQuery } from "react-query";
import { Link } from "react-router-dom";
import { getDashboardSummary } from "../../services/dashboardService";
import { useAuth } from "../../contexts/AuthContext";
import StatCard from "./StatCard";
import ChartCard from "./ChartCard";

const Dashboard = () => {
  const { user } = useAuth();

  const {
    data: summaryData,
    isLoading,
    error,
  } = useQuery("dashboard-summary", getDashboardSummary, {
    refetchInterval: 300000, // Refetch every 5 minutes
  });

  if (isLoading) {
    return (
      <div className="loading-spinner">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger">
        <i className="fas fa-exclamation-triangle me-2"></i>
        Terjadi kesalahan saat memuat data dashboard.
      </div>
    );
  }

  const data = summaryData?.data || {};

  return (
    <div className="fade-in">
      {/* Welcome Section */}
      <div className="content-header">
        <div className="row align-items-center gap-2">
          <div className="col me-auto ">
            <h4 className="mb-1">Selamat Datang, {user?.full_name}!</h4>
            <p className="text-muted mb-0">
              Sistem Pengelolaan Data Rumah - Kabupaten Kepulauan Talaud
            </p>
          </div>
          {/* {user?.role === "admin" ? (
            <div className="col-md-auto">
              <Link to="/housing/add" className="btn btn-primary w-100">
                <i className="fas fa-plus me-2"></i>
                Tambah Data Rumah
              </Link>
            </div>
          ) : null} */}
        </div>
      </div>

      {/* Statistics Cards */}
      <div className="row mb-4">
        <div className="col-md-3 mb-3">
          <StatCard
            title="Total Data Rumah"
            value={data.total || 0}
            icon="fas fa-home"
            color="primary"
            link="/housing"
          />
        </div>
        <div className="col-md-3 mb-3">
          <StatCard
            title="Rumah Milik Sendiri"
            value={
              data.house_ownership?.find(
                (item) => item.house_ownership === "MILIK SENDIRI"
              )?.count || 0
            }
            icon="fas fa-key"
            color="success"
            link="/housing"
          />
        </div>
        <div className="col-md-3 mb-3">
          <StatCard
            title="Laki-laki"
            value={
              data.gender?.find((item) => item.gender === "LAKI-LAKI")?.count ||
              0
            }
            icon="fas fa-male"
            color="info"
            link="/housing"
          />
        </div>
        <div className="col-md-3 mb-3">
          <StatCard
            title="Perempuan"
            value={
              data.gender?.find((item) => item.gender === "PEREMPUAN")?.count ||
              0
            }
            icon="fas fa-female"
            color="warning"
            link="/housing"
          />
        </div>
      </div>

      {/* Charts Row */}
      <div className="row mb-4">
        <div className="col-lg-8 mb-3">
          <ChartCard
            title="Distribusi Kepemilikan Tanah"
            type="bar"
            data={data.land_ownership}
            options={{
              responsive: true,
              plugins: {
                legend: {
                  position: "top",
                },
                title: {
                  display: true,
                  text: "Jumlah berdasarkan kepemilikan tanah",
                },
              },
            }}
          />
        </div>
        <div className="col-lg-4 mb-3">
          <ChartCard
            title="Distribusi Pendidikan"
            type="doughnut"
            data={data.education}
            options={{
              responsive: true,
              plugins: {
                legend: {
                  position: "bottom",
                },
              },
            }}
          />
        </div>
      </div>

      {/* Additional Charts */}
      <div className="row mb-4">
        <div className="col-lg-6 mb-3">
          <ChartCard
            title="Distribusi Pekerjaan"
            type="pie"
            data={data.occupation}
            options={{
              responsive: true,
              plugins: {
                legend: {
                  position: "right",
                },
              },
            }}
          />
        </div>
        <div className="col-lg-6 mb-3">
          <ChartCard
            title="Distribusi Penghasilan"
            type="bar"
            data={data.income}
            options={{
              responsive: true,
              plugins: {
                legend: {
                  position: "top",
                },
              },
            }}
          />
        </div>
      </div>

      {/* Quick Actions */}
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <h5 className="mb-0">
                <i className="fas fa-bolt me-2"></i>
                Akses Cepat
              </h5>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-3 mb-3">
                  <Link to="/housing" className="btn btn-outline-primary w-100">
                    <i className="fas fa-list me-2"></i>
                    Lihat Data Rumah
                  </Link>
                </div>
                {user?.role === "admin" ? (
                  <div className="col-md-3 mb-3">
                    <Link
                      to="/housing/add"
                      className="btn btn-outline-success w-100"
                    >
                      <i className="fas fa-plus me-2"></i>
                      Tambah Data Baru
                    </Link>
                  </div>
                ) : null}
                <div className="col-md-3 mb-3">
                  <Link to="/map" className="btn btn-outline-info w-100">
                    <i className="fas fa-map me-2"></i>
                    Lihat Peta
                  </Link>
                </div>
                <div className="col-md-3 mb-3">
                  <Link to="/reports" className="btn btn-outline-warning w-100">
                    <i className="fas fa-chart-bar me-2"></i>
                    Laporan
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
